import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import PlusToMinus from '../icons/PlusToMinus';
import css from './ExpandCollapser.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Expander = function Expander(_ref) {
  var alignLeft = _ref.alignLeft,
      border = _ref.border,
      child = _ref.child,
      id = _ref.id,
      onClick = _ref.onClick,
      open = _ref.open,
      maxHeight = _ref.openHeight,
      overflow = _ref.overflow,
      title = _ref.title,
      titleComponent = _ref.titleComponent;
  return /*#__PURE__*/_jsxs("li", {
    className: css.wrap,
    id: id,
    children: [/*#__PURE__*/_jsxs("button", {
      "aria-expanded": open,
      className: cc([_defineProperty({}, css.alignLeft, alignLeft), _defineProperty({}, css.border, border), css.button, css.expanderButton]),
      onClick: onClick,
      type: "button",
      children: [titleComponent || title, /*#__PURE__*/_jsx(PlusToMinus, {
        open: open
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.expanderContent, _defineProperty({}, css.open, open)]),
      style: open ? {
        maxHeight: maxHeight,
        overflow: overflow
      } : {
        maxHeight: 0
      },
      children: child
    })]
  });
};

Expander.defaultProps = {
  alignLeft: false,
  border: true,
  openHeight: 200,
  overflow: 'auto',
  titleComponent: false
};
Expander.propTypes = {
  alignLeft: PropTypes.bool,
  border: PropTypes.bool,
  child: PropTypes.element.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  openHeight: PropTypes.number,
  overflow: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string.isRequired,
  titleComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.bool])
};
export default Expander;